import React from 'react';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import Snackbar from '@material-ui/core/Snackbar';

const ErrorSnackbar = () => {
  const errors = useSelector(state => state.errors);
  const isOpen = errors.length !== 0;

  return (
    <div>
      <Snackbar
        open={isOpen}
        autoHideDuration={5000}
        message={R.propOr('', 'message', R.last(errors))}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        style={{ bottom: 0 }}
      />
    </div>
  );
};

export default ErrorSnackbar;
